import type { ReactNode } from 'react'

export interface EmptyStateProps {
  title: ReactNode
  /** One sentence saying what to do next. Not an apology. */
  description?: ReactNode
  /** Alias for `description`. */
  message?: ReactNode
  icon?: ReactNode
  /** Usually a single primary Button. */
  action?: ReactNode
  children?: ReactNode
  className?: string
}

export function EmptyState({
  title,
  description,
  message,
  icon,
  action,
  children,
  className,
}: EmptyStateProps) {
  return (
    <div className={`rs-empty ${className ?? ''}`}>
      {icon ? <span className="rs-empty__icon">{icon}</span> : null}
      <p className="rs-empty__title">{title}</p>
      {(description ?? message) ? <p className="rs-empty__body">{description ?? message}</p> : null}
      {children}
      {action}
    </div>
  )
}
